export default "__VITE_ASSET__4Dhoa6W6__"